import { Neo4jDriverAdapter } from './neo4j-driver-adapter';

export const neo4jDriverAdapter = new Neo4jDriverAdapter();
